import PassengerCard from './PassengerCard';
import { PassengerCardStatus } from './PassengerCard.types';

export default PassengerCard;

export type { PassengerCardStatus };
